import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const CREATE_YIELDBIRD_WORKSPACE_BIDDER: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation createYieldbirdWorkspaceBidder($input: CreateYieldbirdWorkspaceBidderInput!) {
    result: createYieldbirdWorkspaceBidder(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
